module.exports = __webpack_public_path__ + "static/img/IMG_20160224_145237.99617532.jpg";